import { rootNode, initParams } from './initial-dataset';
import { makeDefaultState } from './store-config';

const defaultState = makeDefaultState(initParams);

export { rootNode, initParams, defaultState };
